import { useState, useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { FilmFormValues } from "@/types/inventory";
import { FormControl, FormField, FormItem, FormLabel, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useTranslation } from "@/hooks/useTranslation";
interface ExpirationDateFieldsProps {
  form: UseFormReturn<FilmFormValues>;
}
export function ExpirationDateFields({
  form
}: ExpirationDateFieldsProps) {
  const {
    t
  } = useTranslation();
  const [isValid, setIsValid] = useState(true);
  const [dateError, setDateError] = useState<string | null>(null);

  // Validate date format and range
  const validateDate = (date: string) => {
    // Empty is valid (optional field)
    if (!date) {
      setIsValid(true);
      setDateError(null);
      return true;
    }

    // Check if date is in format YYYY-MM
    const regex = /^\d{4}-\d{2}$/;
    if (!regex.test(date)) {
      setIsValid(false);
      setDateError("Date format must be YYYY-MM");
      return false;
    }

    // Parse date parts
    const [year, month] = date.split('-').map(Number);

    // Validate year (between 1900 and 2100)
    if (year < 1900 || year > 2100) {
      setIsValid(false);
      setDateError("Year must be between 1900 and 2100");
      return false;
    }

    // Validate month (1-12)
    if (month < 1 || month > 12) {
      setIsValid(false);
      setDateError("Month must be between 1 and 12");
      return false;
    }
    setIsValid(true);
    setDateError(null);
    return true;
  };

  // Validate on mount if there's an initial value
  useEffect(() => {
    const initialValue = form.getValues("expiration_date");
    if (initialValue) {
      validateDate(initialValue);
    }
  }, []);
  return <FormField control={form.control} name="expiration_date" render={({
    field
  }) => <FormItem>
          <FormLabel>{t('expiration_date')}</FormLabel>
          <FormControl>
            <Input type="month" placeholder="YYYY-MM" {...field} value={field.value || ""} onChange={e => {
        const value = e.target.value;
        const isValidDate = validateDate(value);
        if (isValidDate) {
          field.onChange(value);
        }
      }} onBlur={e => validateDate(e.target.value)} className={!isValid ? "border-destructive" : ""} />
          </FormControl>
          {dateError && <p className="text-xs font-medium text-destructive">
              {dateError}
            </p>}
          
          <FormMessage />
        </FormItem>} />;
}